import Kanban from './Kanban'

export default Kanban
